import PrivacyPolicy from "@/fragments/PrivacyPolicy";
import TermsAndConditions from "@/fragments/TermsAndConditions";
import { createUser } from "@/services/auth";
import { formatE164 } from "@/services/phone";
import { AutoStories, Edit, ExpandMore } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Drawer,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";

export default function NewUserContainer({
  countryCode,
  phone,
  loading,
  setLoading,
}) {
  const [name, setName] = useState("");
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);

  const [profileImage, setProfileImage] = useState(null);

  const formattedPhone = () => {
    return formatE164(countryCode, phone).e164;
  };

  const handleCreateUser = async () => {
    setLoading(true);
    try {
      await createUser(formattedPhone(), name, agreeToTerms, profileImage);
      // createUser redirects on success; keep the spinner up until the page
      // unloads so the registration form doesn't flash back.
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box sx={{ mt: 3, mb: 2 }}>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar
              src={profileImage ? URL.createObjectURL(profileImage) : null}
              sx={{ width: 110, height: 110 }}
            />
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="profile"
              type="file"
              onChange={(e) => setProfileImage(e.target.files[0])}
            />
            <label htmlFor="profile">
              <Button
                startIcon={<Edit />}
                variant="text"
                color="secondary"
                component="span"
              >
                User Profile
              </Button>
            </label>
          </Box>
        </Box>

        <TextField
          label="Name"
          variant="outlined"
          required
          // helperText="Your full name. ID verification may be required."
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          autoComplete="off"
          sx={{ mt: 2, mb: 4 }}
          InputProps={{
            style: {
              borderRadius: "30px",
            },
          }}
        />

        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            width: "100%",
          }}
          sx={{ mb: 4 }}
        >
          <Checkbox
            checked={agreeToTerms}
            onChange={(e) => setAgreeToTerms(e.target.checked)}
            sx={{ p: 0, mr: 1, mt: 0.5 }}
          />
          <Typography variant="body1" color="darkgray">
            I agree to the{" "}
            <span
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => setTermsOpen(true)}
            >
              Terms and Condtions
            </span>
            <span>, the </span>
            <span
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => setPrivacyOpen(true)}
            >
              Privacy Policy,
            </span>
            <span> and to treat everyone with love and respect.</span>
          </Typography>
        </Box>

        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={handleCreateUser}
          disabled={name.length < 3 || loading || !agreeToTerms}
          startIcon={<AutoStories />}
          style={{ margin: "10px 0", borderRadius: "20px" }}
        >
          OPEN NOTEBOOK
        </Button>
      </Box>
      <TermsAndConditionsDrawer
        open={termsOpen}
        onClose={() => setTermsOpen(false)}
      />
      <PrivacyPolicyDrawer
        open={privacyOpen}
        onClose={() => setPrivacyOpen(false)}
      />
    </Box>
  );
}

function TermsAndConditionsDrawer({ open, onClose }) {
  return (
    <Drawer anchor="bottom" open={open} onClose={onClose}>
      <Box p={2} style={{ height: "90vh" }}>
        <Box style={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={onClose} style={{ float: "right" }}>
            <ExpandMore style={{ fontSize: "30px" }} />
          </IconButton>
        </Box>
        <TermsAndConditions />
      </Box>
    </Drawer>
  );
}

function PrivacyPolicyDrawer({ open, onClose }) {
  return (
    <Drawer anchor="bottom" open={open} onClose={onClose}>
      <Box p={2} style={{ height: "90vh" }}>
        <Box style={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={onClose} style={{ float: "right" }}>
            <ExpandMore style={{ fontSize: "30px" }} />
          </IconButton>
        </Box>
        <PrivacyPolicy />
      </Box>
    </Drawer>
  );
}
